

import XHeader from 'vux/src/components/x-header/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import { Toast } from 'vant';

export default {
components: {
XHeader,
Tab,
TabItem
},
data () {
return {
tabIndex:2,
model:{type:1,pageNumber:0,pageSize:10},
listTem:[],
loading: false,
finished: false,
delectList:[],
manageFlag:false
}
},
created(){
var type=this.$route.query.type;
if(type){
this.model.type=type;
}
},
methods: {
goBack(){
this.$router.push({
path : '/user/index',
query : {}
})
},
onLoad() {

setTimeout(() => {
this.model.pageNumber=this.model.pageNumber+1;
this.$http.post(this.global.httpUrl + '/rest/v1/goods/footmark/getFootMarkList',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
var list = res.body.rows;
for (let i = 0; i < list.length; i++) {
this.listTem.push(list[i]);
}

this.loading = false;

if (this.listTem.length >= res.body.total) {
this.finished = true;
}
}
},function(res){
});
}, 500);
},
addDelectFlag(id){
var index=this.delectList.indexOf(id);
if(index==-1){
this.delectList.push(id);
}else{
this.delectList.splice(index,1);
}
},
getFoot(index){
this.manageFlag=false;
this.delectList=[];
this.$router.push({path:'/user/foot',query:{'type':index}});
if(index==this.model.type){
return;
}
this.model.type=index;
this.finished = false;
this.model.pageNumber=0;
this.listTem=[];
this.onLoad();
},
cancelSelect(){
this.delectList=[];
this.manageFlag=true;
var checkBoxList= document.getElementsByClassName('checkBox');
for (let index = 0; index < checkBoxList.length; index++) {

checkBoxList[index].checked =false;

}

},
delectCollct(){
if(this.delectList.length==0){
this.promptInformation("提示","未选中任何数据");
return;
}
var footIdList=this.delectList.join(',');
console.log(footIdList);
this.$http.post(this.global.httpUrl + '/rest/v1/goods/footmark/delectFootMark',{'footIdList':footIdList},{emulateJSON:true}).then(function(res){
if(res.body.success)
{

this.delectList=[];
this.manageFlag=false;
this.$router.go(0);
}
},function(res){
});
},
goApp(item){

if(item.goods.appId){

window.location.href="/m/mall/app/detail.html?sourceAddress=2&appId="+item.goods.appId;
}else{

window.location.href="/m/mall/app/detail1.html?sourceAddress=2&goodsId="+item.goodsId;
}
},
goPaas(item){


window.location.href="/m/mall/paas/detail.html?sourceAddress=2&appId="+item.goods.appId;

},
goHardWars(item){


window.location.href="/m/mall/hardware/detail.html?sourceAddress=2&goodsId="+item.goodsId;
},
promptInformation(title,content){
this.$vux.alert.show({
title:title,
content:content,
})
}

}
}



// WEBPACK FOOTER //
// ./src/views/user/foot.vue